import Vue from 'vue';
import { Component} from 'vue-property-decorator'
import Title from '@workflow/components/Title.vue'
import ApprovalInfo from '@workflow/components/ApprovalInfo.vue'
import ApprovalStatus from '@workflow/components/ApprovalStatus.vue'
import { mapGetters } from 'vuex';
import * as types from '@workflow/store/types'

@Component({
    components: { Title, ApprovalInfo, ApprovalStatus },
    computed: {
        ...mapGetters({
            current: types.WORKFLOW_CURRENT
        })
    }
})
export default class ApprovalStateContainer extends Vue {

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    current!: any
}
